// extracted by mini-css-extract-plugin
export default {"button":"ButtonIcon_button__s-tab","icon":"ButtonIcon_icon__EpbYG"};